var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('profile_stat_card',{attrs:{"cards":_vm.cards,"loading":_vm.loading,"time":_vm.stats.addedAt,"title":"Matters"},on:{"update":function($event){return _vm.getStats(true)}}})}
var staticRenderFns = []

export { render, staticRenderFns }